import { css, SerializedStyles } from '@emotion/react';
import { DialogBackdropColor } from '../../theming';

// Static styles
export const STATIC_STYLES: SerializedStyles = css`
    --dimmer-blur: 3px;
    --dimmer-bg-color-white: rgba(255, 255, 255, 0.6);
    --dimmer-bg-color-black: rgba(0, 0, 0, 0.6);

    position: absolute;
    inset: 0;

    display: grid;
    place-items: center;

    background-color: var(--dimmer-bg-color);
    backdrop-filter: var(--dimmer-filter);

    z-index: var(--hc-z-index-dimmer);
`;

export function useDynamicStyles(backgroundColor: DialogBackdropColor, blur: boolean): React.CSSProperties {
    return {
        '--dimmer-bg-color': `var(--dimmer-bg-color-${backgroundColor})`,
        '--dimmer-filter': blur ? `blur(var(--dimmer-blur))` : undefined,
    } as React.CSSProperties;
}
